<template>
  <div class="ee-data-select" :style="`width: ${width}px`">
    <i v-if="simple" class="text-icon icon-yzm"></i>
    <div @click="handleShow" :class="`ee-data-select__toggle ee-data-select--${size}`">
      {{curPath}}<i class="text-icon icon-yzm"></i>
    </div>
    <ee-dialog :title="title" v-model="visible">
      <div class="ee-data-select__dialog">
        <div class="ee-data-select__result">
          {{curPath}}<span v-if="errorMsg" class="ee-data-select__error">{{errorMsg}}</span>
        </div>
        <div class="ee-data-select__list">
          <ul class="ee-data-select__tabs">
            <li><a @click="handlePath('all')" href="javascript:;">全部</a></li>
            <li v-for="id in path"><a @click="handlePath(id)" href="javascript:;">{{list[id][1]}}</a></li>
          </ul>
          <div class="ee-data-select__content">
            <ul>
              <li v-for="id in showList"><a @click="handleSelect(list[id][0])" :class="{active: isActive(id)}" href="javascript:;">{{list[id][1]}}</a></li>
            </ul>
          </div>
        </div>
        <div class="ee-data-select__tool-bar">
          <div @click="handleCancel" class="btn btn-small">取消</div>
        </div>
      </div>
    </ee-dialog>
  </div>
</template>
<script>
  export default {
    compName: 'ee-data-select',
    props: {
      value: [Array, String],
      title: String,
      resource: Object,
      width: {
        type: Number,
        default: 200
      },
      size: {
        type: String,
        default: 'default'
      },
      simple: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      handleCancel () {
        this.selects = this.old.selects
        this.selectedPath = this.old.selectedPath
        this.$emit('input', [...this.old.value])
        this.visible = false
      },
      handleConfirm () {
        this.$emit('input', [...this.selects])
        this.visible = false
      },
      handleShow () {
        this.visible = !this.visible
      },
      handlePath (id) {
        if (id === 'all') {
          this.path = []
        } else {
          while (this.path[this.path.length - 1] !== id) {
            this.path.pop()
          }
        }
      },
      handleSelect (id) {
        if (this.relations[id]) {
          this.path.push(id)
        } else {
          this.selectedPath = [...this.path, id]
          this.visible = false
          this.$emit('input', id)
        }
      },
      isActive (id) {
        if (this.value === id || this.path.includes(id)) {
          return true
        }
        for (let i = 0, len = this.selectedPath.length; i < len; i++) {
          const selected = this.selectedPath[i]
          if (Array.isArray(selected) && selected.includes(id) || selected === id) {
            return true
          }
        }
        return false
      },
      initPath () {
        const that = this
        const getPath = id => {
          const result = []
          let next = id
          const keys = Object.keys(that.relations)
          const find = cityId => {
            for (let i = 0, len = keys.length; i < len; i++) {
              if (that.relations[keys[i]].includes(cityId)) {
                return keys[i]
              }
            }
            return null
          }
          while (next && next !== 'all') {
            result.unshift(next)
            next = find(next)
          }
          return result
        }
        if (this.value) {
          this.selectedPath = getPath(this.value)
          this.path = this.selectedPath.slice(0, this.selectedPath.length - 1)
        } else {
          this.selectedPath = []
        }
      }
    },
    data () {
      return {
        visible: false,
        selects: this.value || [],
        path: [],
        selectedPath: [],
        errorMsg: '',
        old: null,
        ...this.resource
      }
    },
    watch: {
      visible () {
        if (this.visible) {
          this.old = {
            value: Array.isArray(this.value) ? [...this.value] : this.value,
            selects: [...this.selects],
            selectedPath: [...this.selectedPath]
          }
        }
      },
      value () {
        if (this.value && (!this.selectedPath || this.selectedPath.length === 0)) {
          this.initPath()
        }
      }
    },
    computed: {
      showList () {
        const id = this.path[this.path.length - 1]
        if (id) {
          return this.relations[id]
        } else {
          return this.relations['all']
        }
      },
      curPath () {
        return this.selectedPath.map(k => this.list[k] && this.list[k][1] || '').join('-')
      }
    },
    created () {
      this.initPath()
    }
  }
</script>
<style>
@import "../style/vars.css";
@component-namespace ee {
  @b data-select {
    @m xlarge {
      height: 54px;
      line-height: 54px;
    }
    @m large {
      height: 48px;
      line-height: 48px;
    }
    @m middle {
      height: 42px;
      line-height: 42px;
    }
    @m default {
      height: 36px;
      line-height: 36px;
    }
    @m small {
      height: 30px;
      line-height: 30px;
    }
    @m tiny {
      height: 24px;
      line-height: 24px;
    }
    @e toggle {
      @utils-ellipsis;
      cursor: pointer;
      position: relative;
      background-color: #fff;
      border: 1px solid var(--border-color);
      padding: 0 20px 0 10px;
      i.text-icon {
        position: absolute;
        top: 50%;
        right: 3px;
        transform: translateY(-50%);
        color: #28a7e1;
      }
    }
    @e result {
      height: 30px;
    }
    @e tabs {
      @utils-clearfix;
      border-bottom: 1px solid #ddd;
      li {
        float: left;
        border: 1px solid #ddd;
        margin-bottom: -1px;
        margin-right: 5px;
        background-color: #f2f2f2;
        &.active {
          border-bottom-color: #f2f2f2;
        }
        &:last-child {
          border-bottom-color: #f2f2f2;
        }
        a {
          display: block;
          padding: 3px 10px;
        }
      }
    }
    @e content {
      border: 1px solid #ddd;
      border-top: 0 none;
      background-color: #f2f2f2;
      ul {
        @utils-clearfix;
        padding: 30px;
        li {
          float: left;
          margin-right: 20px;
          margin-bottom: 5px;
          a {
            padding: 3px 10px;
            border-radius: 3px;
            &.active,
            &:hover {
              background-color: var(--main-color);
              color: #fff;
            }
          }
        }
      }
    }
    @e tool-bar {
      text-align: center;
      .btn {
        width: 70px;
        margin: 10px;
        border-radius: 3px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/packages/localdata/DataSelect.vue?54ac3eda